import { render, staticRenderFns } from "./EditionToolBar.vue?vue&type=template&id=5345205c&scoped=true"
import script from "./EditionToolBar.vue?vue&type=script&lang=ts"
export * from "./EditionToolBar.vue?vue&type=script&lang=ts"
import style0 from "./EditionToolBar.vue?vue&type=style&index=0&id=5345205c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5345205c",
  null
  
)

export default component.exports